const DeviceTypeIcon = ({ type = 'audioinput' }) => {
  return (
    <div className="icon square-big">
      <SvgIconsMicrophoneSettings alt={type} />
    </div>
  )
}

export default DeviceTypeIcon
